module.exports = __webpack_public_path__ + "img/Hercules.f5ac0acc.png";